import Router from 'next/router';
import { useReduxState } from 'hooks';
import api from 'api';
import { RemoveAdminButton } from 'components/common/admins';

import { OwnerOrAdminUser } from './OwnersAndAdminsManager';

interface Props {
  disabled: boolean;
  fallbackUrl: string;
  isAdminGroup: boolean;
  updateOwnersAndAdmins: ({
    updatePageState
  }: {
    updatePageState: boolean;
  }) => Promise<void>;
  url: string;
  user: OwnerOrAdminUser;
}

const OwnersAndAdminsRemove = ({
  disabled,
  fallbackUrl,
  isAdminGroup,
  updateOwnersAndAdmins,
  url,
  user
}: Props) => {
  const { user: loggedInUser } = useReduxState();

  const remove = async () => {
    try {
      const urlFragment = url.split('/').slice(0, -1);
      const removeUrl = isAdminGroup
        ? `${urlFragment.join('/')}/admin-groups/${user.id}`
        : `${url}/${user.id}`;

      const response = await api.delete(removeUrl);

      if (
        !loggedInUser.roles.includes('superadmin') &&
        (response.data?.userHasAccess === false ||
          response.data?.userIsOwner === false)
      )
        Router.push(fallbackUrl);
      else await updateOwnersAndAdmins({ updatePageState: true });

      return true;
    } catch (err) {}
  };

  return (
    <RemoveAdminButton
      disabled={disabled}
      isAdminGroup={isAdminGroup}
      isOwner={!user.permissions}
      onConfirm={remove}
    />
  );
};

export default OwnersAndAdminsRemove;
